module.exports = __webpack_public_path__ + "static/DEV2-10e45d4d784a7d585fd3e596a86f66c9.png";